module.exports = __webpack_public_path__ + "static/media/part-09.43ede15a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-09.jpg
// module id = 942
// module chunks = 0